import { ErrorArgs, EventArgs } from './ga-enums-interfaces';
import { DeepMap, FieldError } from 'react-hook-form';
import { IFormInput } from '../components/domains/forms/patient/enrollment.models';
import { Question } from '../components/hoc/context/product/context-model';
import { ContextService } from '../components/hoc/context/product/context';
import { EnrollmentContextService } from '../components/hoc/context/enrollment/enrollment-context';

export type ChoiceType = string | number | boolean | undefined;

export abstract class Analytics {
	constructor() {}

	abstract sendEvent(eventArgs: EventArgs): void;

	abstract sendSimpleEvent(
		category: string,
		action: string,
		label: string,
		pageRequestTime?: number
	): void;

	abstract sendErrors(
		screen: string,
		errors: ErrorArgs | DeepMap<IFormInput, FieldError>
	): void;
	abstract sendQuestionEvent(
		question: Question,
		choice: ChoiceType,
		label: string,
		actualChoice: string | undefined,
		ctxt: ContextService,
		enrollmentCtxt: EnrollmentContextService
	): void;
}
export default Analytics;
